import { action, observable, runInAction, makeObservable } from 'mobx';
import { request } from '@/framework/network/request'
import Role from '../model/Role'
import User from '../model/User'

export default class UserStore {
  loading: boolean;
  showEditDrawer: boolean;
  saving: boolean;
  loadingRoles: boolean;

  list: Array<User>;
  search: any;
  pagination: any;
  user: User;
  roles: Array<Role>;

  constructor () {
    makeObservable(this, {
      loading: observable,
      showEditDrawer: observable,
      saving: observable,
      loadingRoles: observable,
      list: observable,
      search: observable,
      pagination: observable,
      user: observable,
      roles: observable,
      fetchList: action,
      fetchUser: action,
      saveUser: action,
      fetchRoles: action,
      del: action,
      showForm: action,
      hideForm: action
    });

    this.showEditDrawer = false
    this.loading = false
    this.saving = false
    this.loadingRoles = false

    this.list = []
    this.search = {}
    this.pagination = {
      pageSizeOptions: ['10', '20', '30', '50', '100'],
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total: string) => `共 ${total} 条记录`
    }
    this.user = new User()
    this.roles = []
  }

  /**
   * 获取用户列表
   * @param page 页码，从0开始
   * @param size 分页条数
   * @param search 查询条件
   */
  fetchList = async (page: number = 0, size: number = 10, search: any = {}) => {
    runInAction(() => {
      this.loading = true
    })
    const res = await request.get(`/u/users:search`, { ...search, page, size })
    runInAction(() => {
      this.search = search
      this.list = res.content
      this.pagination = {
        ...this.pagination,
        total: res.totalElements,
        current: res.number + 1,
        pageSize: res.size,
      }
      this.loading = false
    })
  };

  /**
   * 获取用户信息
   * @param id 用户id
   */
  fetchUser = async (id?: number) => {
    this.loading = true
    if (id) {
      const res = await request.get(`/u/user/${id}`)
      runInAction(() => {
        this.user = {
          ...res.data,
          password: '',
          roleIds: res.data.roles.map((item: Role) => `${item.id}`)
        }
        this.loading = false
      })
    } else {
      runInAction(() => {
        this.user = new User()
        this.loading = false
      })
    }
  };

  /**
   * 保存用户
   * @param user
   */
  saveUser = async (user: User) => {
    this.loading = true
    if (user.id) {
      await request.put(`/u/user/${this.user.id}`, user)
    } else {
      await request.post(`/u/user`, user)
    }
    const { current, pageSize } = this.pagination
    await this.fetchList(current - 1, pageSize, this.search)
    runInAction(() => {
      this.showEditDrawer = false
    })
  };

  /**
   * 获取角色列表
   * @param search
   * @param size
   */
  fetchRoles = async (search: string = '', size: number = 1000) => {
    this.loadingRoles = true
    const res = await request.get(`/u/roles:search`, { search, size })
    runInAction(() => {
      this.loadingRoles = false
      this.roles = res.data.content
    })
  };

  /**
   * 删除用户
   * @param id
   */
  del = async (id: number) => {
    await request.delete(`/u/user/${id}`)
    const { current, pageSize } = this.pagination
    await this.fetchList(current - 1, pageSize, this.search)
  };

  showForm = () => {
    this.showEditDrawer = true
  };

  hideForm = () => {
    this.showEditDrawer = false
  };
}
